import FavsWidget from './FavsWidget';
import { filmFavsConfig } from './config';

const FilmFavs = () => <FavsWidget config={filmFavsConfig} />;

export default FilmFavs;
